export const getDownloadUserAccountInfo = async (
  setDownloadUserAccountInfo,
  setIsNewUser,
  setAuthenticationChecked,
) => {
  let endpoint = "/user/download/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
      credentials: "include",
    });

    if (!res.ok) {
      if (res.status === 401) {
        setAuthenticationChecked("UNAUTHORIZED");
        return;
      } else if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
        return;
      }
      throw new Error(`Error ${res.status} ${res.statusText}`);
    }

    res.json().then((res) => {
      if (res.error == null) {
        setDownloadUserAccountInfo(res.data);
        setAuthenticationChecked(null);
      } else if (
        res.error === "Access denied. You don't have the required permissions."
      ) {
        setAuthenticationChecked("FORBIDDEN");
      } else if (
        res.error === "Authentication required to access this resource"
      ) {
        setAuthenticationChecked("UNAUTHORIZED");
      } else {
        setAuthenticationChecked(res.error);
      }
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    } else {
      setAuthenticationChecked(err.message);
    }
  }
};
export const updateDownloadUserAcc = async (userAcc) => {
  let endpoint = "/user/download/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userAcc),
      credentials: "include",
    });

    const data = await res.json().catch(() => null);
    if (!res.ok) {
      if (res.status === 401) {
        alert("Session expired. Please login again.");
      } else if (res.status === 403) {
        alert("Access denied - You don't have the required permissions.");
      } else {
        alert(`${data?.error?.code} - ${data?.error?.message}`);
      }
      return;
    }

    if (data?.error) {
      if (data.error.message?.includes("Authentication required")) {
        alert("Session expired. Please login again.");
      } else if (data.error.message?.includes("Access denied")) {
        alert("Access denied - You don't have the required permissions.");
      } else {
        alert(`${data.error.code} - ${data.error.message}`);
      }
    } else {
      alert("Account has been updated successfully.");
    }
  } catch (err) {
    alert(`Error: ${err.message}`);
  }
};

export const deleteDownloadUserAcc = async (userAcc) => {
  let endpoint = "/user/download/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    });

    if (!res.ok) {
      if (res.status === 401) {
        alert("Session expired. Please login again.");
      } else if (res.status === 403) {
        alert("Access denied - You don't have the required permissions.");
      } else {
        throw new Error(`Error ${res.status}: ${res.statusText}`);
      }
      return;
    }

    const data = await res.json();
    if (data.error) {
      if (data.error.includes("Authentication required")) {
        alert("Session expired. Please login again.");
      } else if (data.error.includes("Access denied")) {
        alert("Access denied - You don't have the required permissions.");
      } else {
        alert(`Error: ${data.error}`);
      }
    } else {
      alert("Account has been successfully deleted.");
    }
  } catch (err) {
    alert(`Failed to delete account: ${err.message}`);
  }
};
